function open (url) {
  window.open(url)
}

function parseDataUrl (url) {
  const parts = url.slice(5).split(';')
  const payload = parts[parts.length - 1].split(',')
  const value = {
    type: parts[0],
    [payload[0]]: payload[1]
  }

  if (parts.length > 2) {
    parts.slice(1, parts.length - 1).forEach(attribute => {
      const a = attribute.split('=')

      value[a[0]] = a[1]
    })
  }

  return value
}

export default {
  open,
  parseDataUrl
}